import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { getAllCMSUsers, getContactUsData } from "../../../services/CommonService";
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import { exportToExcel } from '../../../Utils/common-Excel';



const AdminUserControl = () => {
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [typeofRole, setTypeRole] = useState([]);
    const [data, setData] = useState([]); // raw contact data
    const [mergedArray, setMergedArray] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const itemsPerPage = 5;

    useEffect(() => {
        const typologyDa = JSON.parse(localStorage.getItem('roledata'));
        if (typologyDa) {
            setTypeRole(typologyDa);
        }
        fetchContacts();
    }, []);

    useEffect(() => {
        // Map only when both data and typeofRole are available
        if (data.length && typeofRole.length) {
            const updated = data.map(item => {
                const matchedRole = typeofRole.find(role => role.id == item.role);
                return {
                    ...item,
                    roleName: matchedRole ? matchedRole.name : null,
                };
            });
            setMergedArray(updated);
        }
    }, [data, typeofRole]);



    const fetchContacts = async () => {
        try {
            setLoading(true);
            // Replace with your actual API endpoint
            const response = await getAllCMSUsers();
            if (!response.status == 200) {
                throw new Error('Failed to fetch contacts');
            }
            const rawData = response.data;
            setData(rawData);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text:  err?.response?.data?.message || err?.message,
            });
        }
    };

    // Format date to a more readable format
    const formatDate = (dateString) => {
        const date = moment(dateString).format('DD-MM-YYYY');
        return date;
    };

    // excel download
    const handleDownloadExcel = () => {
        const formatDate = (isoString) => {
            const date = new Date(isoString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };
        const exportData = currentContacts.map((item, index) => ({
            "S.No.": index + 1,
            Name: item.name,
            Email: item.email,
            "Role":item.roleName,
            "Status":item.is_deleted === 0 ? "Active" : "Inactive",
            "Created on": formatDate(item.created_at),
             "Updated on": formatDate(item.updated_at),
        }));
        exportToExcel(exportData, 'CmsUserList', 'CmsUser', 'CmsUser Report',null,null);
    };


    // Filter contacts based on search term and date range
    const filteredContacts = mergedArray.filter(contact => {
        const matchesSearch = (
            contact?.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            contact?.email?.toLowerCase().includes(searchTerm?.toLowerCase())
        );
        const contactDate = moment(contact.created_at);
        const isInDateRange = contactDate.isSameOrAfter(moment(startDate).startOf('day')) &&
            contactDate.isSameOrBefore(moment(endDate).endOf('day'));
        return matchesSearch;
    });

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentContacts = filteredContacts.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredContacts.length / itemsPerPage);

    // Generate page numbers
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                Error: {error}
            </div>
        );
    }
    const openImg = () => {
        setShowModal(true);
    };
    return (
        <div className="container-fluid mt-4">
            <div className="card shadow">
                <div className="card-header adminCardHeader d-flex justify-content-between text-white">
                    <h4>Admin Control</h4>
                    <Link to="/admin/registration">
                        <button
                            className="btn btn-warning btn-sm"
                        >
                            <i className="bi bi-plus-circle me-1"></i>Admin Registration
                        </button>
                    </Link>
                </div>
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center">
                                <label className="me-2">Search:</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value)
                                        setCurrentPage(1);
                                    }}
                                    style={{ width: '150px' }}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-end align-items-center">
                                <button className="btn btn-success mb-2" onClick={handleDownloadExcel}>
                                    <i className="bi bi-file-earmark-excel-fill me-2"></i>
                                    Excel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>UserName (Email)</th>
                                    <th>Role</th>
                                    <th>Created On</th>
                                    <th>Status</th>
                                    <th>Update</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentContacts.length > 0 ? (
                                    currentContacts.map((contact, i) => (
                                        <tr key={contact.id}>
                                            <td>{i + 1}</td>
                                            <td>{contact.name}</td>
                                            <td>{contact.email}</td>
                                            <td>{contact.roleName}</td>
                                            <td>{formatDate(contact.created_at)}</td>
                                            <td>
                                                <div className={`status-toggle ${contact.is_deleted === 0 ? 'active' : 'inactive'}`}>
                                                    <span className="status-label">
                                                        {contact.is_deleted === 0 ? 'Active' : 'Inactive'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <Link to="/admin/registration" state={{ userData: contact }}>
                                                    <i
                                                        className="bi bi-pencil-fill text-primary me-2"
                                                        style={{ cursor: "pointer" }}

                                                    ></i>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination */}
                    {totalPages > 1 && (
                        <nav aria-label="Contact pagination">
                            <ul className="pagination pagination-sm justify-content-end">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>
                                {pageNumbers.map(number => (
                                    <li
                                        key={number}
                                        className={`page-item ${currentPage === number ? 'active' : ''}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(number)}
                                        >
                                            {number}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                    <div className="text-center text-muted mt-3">
                        {filteredContacts.length > 0 ? (
                            <small>Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredContacts.length)} of {filteredContacts.length} contacts</small>
                        ) : (
                            <small>No data to display</small>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default AdminUserControl;